<script setup lang="ts">
import Revenue from "@/views/playground/planner/business-management/settlement-management/revenue/Revenue.vue";
</script>

<template>
  <revenue></revenue>
</template>

<style scoped></style>
